import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';
import JBIFrameHolder from 'components/essentials/JBIFrameHolder';
import FinancingCtaButton from 'components/essentials/FinancingCtaButton';
import PDPOrderSwatchesSidebar from 'components/consumer/PDP/PDPOrderSwatchesSidebar';
import CtaButton from 'components/essentials/Cta/CtaButton';
import CtaLink from 'components/essentials/Cta/CtaLink';

const ToggleCTALinkButton = props => {
  const { toggleInputType, style = {}, isHovered, linkClassName } = props;
  const CTAComponentType = toggleInputType?.selected?.value
    ? toggleInputType.selected.value?.replace(' ', '')
    : '';
  const [iFrameVisibility, setiFrameVisibility] = useState(false);
  const [isOrderSwatchesSidebarOpen, setIsOrderSwatchesSidebarOpen] = useState(
    false
  );
  const [isButtonEmbedded] = useState(() => {
    if (
      toggleInputType &&
      toggleInputType.selected &&
      CTAComponentType === 'CTAButton'
    ) {
      if (
        toggleInputType.ctaButton.embedCode.enabled &&
        toggleInputType.ctaButton.embedCode.value.includes('<a ')
      ) {
        return true;
      }
    }
    return false;
  });

  let finalCTAButton = null;
  if (
    toggleInputType &&
    toggleInputType.selected &&
    CTAComponentType === 'CTAButton' &&
    toggleInputType.ctaButton
  ) {
    if (
      toggleInputType.ctaButton.type &&
      (toggleInputType.ctaButton.type === 'Affirm' ||
        toggleInputType.ctaButton.type === 'Financing')
    ) {
      finalCTAButton = (
        <FinancingCtaButton
          style={style}
          color={toggleInputType.ctaButton.color || 'black'}
          styling={toggleInputType.ctaButton.style || 'solid-button'}
        >
          {toggleInputType.ctaButton.content}
        </FinancingCtaButton>
      );
    } else {
      finalCTAButton = (
        <CtaButton
          onClick={() => {
            setIsOrderSwatchesSidebarOpen(true);
          }}
          color={toggleInputType.ctaButton.color || 'black'}
          styling={toggleInputType.ctaButton.style || 'solid-button'}
          style={style}
          isHovered={isHovered}
          className="!block !m-0"
        >
          {toggleInputType.ctaButton.content}
        </CtaButton>
      );
    }
  }
  return (
    <>
      {isOrderSwatchesSidebarOpen && (
        <PDPOrderSwatchesSidebar
          show={isOrderSwatchesSidebarOpen}
          onClose={() => {
            setIsOrderSwatchesSidebarOpen(false);
          }}
          closeSlidePanel={() => {
            setIsOrderSwatchesSidebarOpen(false);
          }}
        />
      )}
      {toggleInputType &&
        toggleInputType.selected &&
        CTAComponentType === 'CTALink' &&
        !!toggleInputType.ctaLink &&
        toggleInputType.ctaLink.content && (
          <CtaLink
            to={toggleInputType.ctaLink.linkTo}
            color={toggleInputType.ctaLink.color}
            styling={toggleInputType.ctaLink.style || 'solid-button'}
            style={style}
            isHovered={isHovered}
            className={`!block !m-0 ${linkClassName}`}
          >
            {toggleInputType.ctaLink.content}
          </CtaLink>
        )}
      {toggleInputType &&
        toggleInputType.selected &&
        CTAComponentType === 'CTAButton' &&
        !!toggleInputType.ctaButton &&
        toggleInputType.ctaButton.content && (
          <div>
            {toggleInputType.ctaButton.embedCode.enabled && isButtonEmbedded && (
              <div
                className="embed-button"
                dangerouslySetInnerHTML={{
                  __html: toggleInputType.ctaButton.embedCode.value,
                }}
              />
            )}
            {toggleInputType.ctaButton.embedCode.enabled &&
              !isButtonEmbedded &&
              iFrameVisibility && (
                <JBIFrameHolder
                  isOpen={iFrameVisibility}
                  onClose={setiFrameVisibility}
                  script={toggleInputType.ctaButton.embedCode.value || ''}
                />
              )}
            {!isButtonEmbedded && finalCTAButton}
          </div>
        )}
    </>
  );
};

ToggleCTALinkButton.propTypes = {
  toggleInputType: PropTypes.shape({
    selected: PropTypes.shape({
      value: PropTypes.string,
    }),
    ctaButton: PropTypes.shape({
      content: PropTypes.string,
      embedCode: PropTypes.shape({
        enabled: PropTypes.bool,
        value: PropTypes.string,
      }),
      type: PropTypes.string,
      color: PropTypes.string,
      style: PropTypes.string,
    }),
    ctaLink: PropTypes.shape({
      content: PropTypes.string,
      linkTo: PropTypes.string,
      color: PropTypes.string,
      style: PropTypes.string,
    }),
  }),
  style: PropTypes.shape({
    height: PropTypes.string,
    width: PropTypes.string,
  }),
  isHovered: PropTypes.bool,
  linkClassName: PropTypes.string,
};

export default withRouter(ToggleCTALinkButton);
